// import config from '@utils/constants/config';

import { environment } from "@utils/constants/environment";

export function getPublicMediaUrl(image: string | null | undefined) {
  if (!image) return "";

  if (image.startsWith("http")) {
    return image;
  }

  return `${environment.REACT_APP_Services_URL}/api/media/v1/Media/public/${image}`;
}
